import React from "react";
import styled from 'styled-components'

import {
  Container,
  Row,
} from "reactstrap";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import LogisticsBackground from 'assets/img/logistics123.png';
import { useTranslation } from 'react-i18next'

const MainText = styled.h5`
`

const BackImage = styled.img`
  height: 600px;
  width: 100%;
`

function ProfilePage() {
  const { t } = useTranslation()
  return (
    <>
      <IndexNavbar />
      <BackImage src={LogisticsBackground} alt='logistics'/>
      <Container>
      <Row>
        <MainText>
        <h4>
            <b>
                {t('Water')}
            </b>
        </h4>
        <h4>
            <b>
            {t('WaterChoose')}
            </b>
        </h4>
        {t('WaterTypes')}
 <ul>
     <li>
     {t('WaterTypes1')}
     </li>
     <li>
     {t('WaterTypes2')}
     </li>
     <li>
     {t('WaterTypes3')}
     </li>
     <li>
     {t('WaterTypes4')}
     </li>
     <li>
     {t('WaterTypes5')}
     </li>
 </ul>

 {t('WaterClass')}

<ul>
    <li>
    Handysize Class: 260 – 1000 TEU;
    </li>
    <li>
    Handymax Class: 1000 – 1700 TEU;
    </li>
    <li>
    Feeder Class: 1700 – 2500 TEU;
    </li>
    <li>
    Sub-Panamax Class: 2500 – 4000 TEU;
    </li>
    <li>
    Panamax Class: 4000 – 7000 TEU;
    </li>
    <li>
    Post-Panamax Class: 7000 – 13000 TEU;
    </li>
    <li>
    Super-Post-Panamax Class/E-Class: более 13000 TEU;
    </li>
    <li>
    Explorer Class: более 16600 TEU;
    </li>
    <li>
    Triple E-Class: более 18200 TEU;
    </li>
    <li>
    Post-Triple E-Class: более 21000 TEU.
    </li>
</ul>


<h4><b>{t('WaterOrganization')}</b></h4>

{t('WaterOrganizationText')}        
 
<h4><b>{t('WaterFraxt')}</b></h4> 
 
{t('WaterFraxtText')}

<h4><b>{t('WaterFraxtBroker')}</b></h4>

{t('WaterFraxtBrokerText')}

<h4><b>{t('WaterAgent')}</b></h4>

{t('WaterAgentText')}

<h4><b>{t('WaterCompany')}</b></h4>

{t('WaterCompanyText')}

<h4><b>{t('WaterSurveyer')}</b></h4> 

{t('WaterSurveyerText')}

<h4><b>{t('Konosament')}</b></h4>

{t('KonosementText')}
        <br />
        <br />
        1. {t('Konosament1')}
        <br />
        2. {t('Konosament2')}
        <br />
        3. {t('Konosament3')}
        <br />
        4. {t('Konosament4')}
        <br />
        5. {t('Konosament5')}
        <br />
        6. {t('Konosament6')}
        <br />
        7. {t('Konosament7')}
        <br />
        8. {t('Konosament8')}
        <br />
        9. {t('Konosament9')}
        </MainText>
        <Row>
       
        </Row>
      </Row>
      <DemoFooter />
      </Container>
    </>
  );
}

export default ProfilePage;
